module.exports = __webpack_public_path__ + "static/HUIPUT_slogan_EN-02-9adc937e4434d518eb5e995b73bf234f.svg";